/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import { array, bool, func, object, string } from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { get} from 'lodash';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import BobConfirmButton from '../../../components/BobConfirmButton';
import { Editor, EditorTools, EditorToolsSettings, EditorUtils, ProseMirror  } from '@progress/kendo-react-editor';
import { connect,useDispatch } from 'react-redux';
import classes from '../CreateEntityModal.module.css';
import aclasses from './AnnouncementsPage.module.css';
import Switch from '../../../components/FormFields/Switch';
import * as DashboardActions from '../../../actions/dashboardActions';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const {
    EditorState,
    EditorView
} = ProseMirror;

const {
    imageResizing,
    pasteCleanup,
    sanitize,
    sanitizeClassAttr,
    sanitizeStyleAttr,
    removeAttribute,
  } = EditorUtils;

const pasteSettings = {
    convertMsLists: true,
    attributes:     {
      class:  sanitizeClassAttr,
      style:  sanitizeStyleAttr,
      width:  () => {},
      height: () => {},
      src:    () => {},
      '*':    removeAttribute,
    },
};

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    ForeColor,
    BackColor,
    DeleteTable,
    MergeCells,
    SplitCell
} = EditorTools;

const { foreColor, backColor } = EditorToolsSettings;

const CustomForeColor = props => {
    const { view } = props;
    const { style, commandName, colorPickerProps } = foreColor;
    const onChange = React.useCallback(
        (event) => {
            if (view) {
                EditorUtils.applyInlineStyle(
                    view,
                    { style: style, value: event.value },
                    commandName
                );
            }
        },
        [view]
    );

    return (
        <ForeColor 
            {...props} 
            colorPickerProps={{
                ...colorPickerProps,
                onChange,
                view: 'gradient',
                icon: 'foreground-color'
            }}
            style={style}
            commandName={commandName} 
        />
    );
};

const CustomBackColor = props => {
    const { view } = props;
    const { style, commandName, colorPickerProps } = backColor;
    const onChange = React.useCallback(
        (event) => {
            if (view) {
                EditorUtils.applyInlineStyle(
                    view,
                    { style: style, value: event.value },
                    commandName
                );
            }
        },
        [view]
    );

    return (
        <BackColor
            {...props}
            colorPickerProps={{
                ...colorPickerProps,
                onChange,
                view: 'gradient',
                icon: 'background'
            }}
            style={style}
            commandName={commandName}
        />
    );
};

const ValidationSchema = Yup.object().shape({
    title: Yup.string()
        .required(),
    type: Yup.string()
        .required(),
    announcementContent: Yup.string()
        .required(),
    startDt: Yup.string()
        .required(),
    startTime: Yup.string()
        .required(),
    version: Yup.string()
        .required()
});

const ANNOUNCEMENT_TYPES = [
    {
        id:   0,
        name: 'Release Notes' 
    }
];
const AnnouncementCreate = ({
    isLoading,
    toggleLoading,
    announcementCreate,
    selectedAnnouncement,
    createAnnouncement,
    updateAnnouncement,
    updateActiveAnnouncement,
    handleBackClick,
    currentUser,
    ...props
}) => {
    const [checked, setChecked] = useState(false);
    // eslint-disable-next-line no-unused-vars

    const [editorValue, setEditorValue] = useState('');
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    const [isPreview, setIsPreview] = useState(false);
    const [previewObj,setPreviewObj] = useState({});
    const dispatch = useDispatch();

    const previewClicked = () =>{
        setIsPreview(true);
        setPreviewObj({title: formik.values.title, version: formik.values.version,announcementContent: editorValue?editorValue:formik.values.announcementContent});
    };

    let formVal = {
        initialValues: {
            title:               announcementCreate?'': get(selectedAnnouncement, 'title', ''),
            type:                announcementCreate?0: get(selectedAnnouncement, 'announcementType', 0),
            announcementContent: announcementCreate?'': get(selectedAnnouncement, 'announcementContent', ''),
            version:             announcementCreate?'': get(selectedAnnouncement, 'version', ''),
            publish:             announcementCreate?'': get(selectedAnnouncement, 'publish', ''),
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {

        }
       
    };
    if (formVal.initialValues.type === 'ReleaseNote') {
        formVal.initialValues.type = 0;
    }
    let _startDt = null;
    let _endDt = null;

    if (!announcementCreate) {
        formVal.initialValues.publish = selectedAnnouncement && (selectedAnnouncement.status ==='Active') ? true:false;
        if (selectedAnnouncement && selectedAnnouncement.status ==='Inactive') {
            formVal.initialValues.publish = false;
        }
        const sDate = Date.parse(selectedAnnouncement.startDate);
        const eDate = Date.parse(selectedAnnouncement.endDate);
        if (isNaN(sDate) === false) {
            _startDt = moment(selectedAnnouncement.startDate).toDate();
        }
        if (isNaN(eDate) === false) {
            _endDt = moment(selectedAnnouncement.endDate).toDate();
        }
    }

    const [startDt, setStartDt] = useState(_startDt ? _startDt : new Date());
    const [endDt, setEndDt] = useState(_endDt ? _endDt : new Date());
    
    const formik = useFormik(formVal);

    const toggleChecked = () => {
        setChecked((prev) => !prev);
    };

    const handleSave = () => {
        const save = async () => {
            let response = null;
            let body = {
                'title':               formik.values.title,
                'announcementContent': editorValue?editorValue:formik.values.announcementContent,
                'announcementType':    'ReleaseNote',
                'version':             formik.values.version,
                'startDate':           startDt?startDt.toISOString():new Date().toISOString()
            };

            if (!checked) {
                body.startDate = null;
            }

            if (body.title && body.announcementContent && body.version) {
                if (selectedAnnouncement && selectedAnnouncement.id) {
                    if (selectedAnnouncement.status === 'Active') {
                        delete body.announcementType;
                        delete body.startDate;
                        response = await updateActiveAnnouncement(body,selectedAnnouncement.id);
                    }
                    else {
                        body.id = selectedAnnouncement.id;
                        response = await updateAnnouncement(body,selectedAnnouncement.id);
                    }
                }
                else {
                    response = await createAnnouncement(body);
                }
                if (response) {
                handleBackClick(response);
                }
            }
            else {
                dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            }
        };

        save();  
    };

    const onEditorChange = (event) => {
        setEditorValue(event.html);
    };

    const onMount = event => {
        const {
            plugins,
            doc
        } = event.viewProps.state;
        
        return new EditorView({
                mount: event.dom
            }, 
            {
                ...event.viewProps,
                state: EditorState.create({
                    doc,
                    plugins: [...plugins, imageResizing()]
                })
            }
        );
    };
      
    useEffect(() => {
        window.scrollTo(0,document.body.scrollHeight);
        if ( selectedAnnouncement && selectedAnnouncement.id )  { 
            previewClicked();
            let publish = false;
            if (!announcementCreate) {
                publish = selectedAnnouncement && (selectedAnnouncement.status ==='Active' || selectedAnnouncement.status ==='Inactive') ? true:false;
            }
            if (selectedAnnouncement && selectedAnnouncement.status ==='Inactive') {
                publish = false;
            }
            setChecked(publish);
        }
    }, [selectedAnnouncement]);

    return (
        <div className={`${aclasses.userformColumn} announcement-create-page`}>
            <div className={classes.userDetails}>
                <div className={`${classes.UserInputColumn} ${aclasses.FirstCol}`}>
                    <p  className={classes.userFormTitleField}>Details</p>
                    <div className={classes.inputs}>
                        <div className={classes.formRow}>
                            <FormControl className={classes.userInputWrapper} style={{width: 100}}>
                                <TextField
                                    id="version"
                                    name="version"
                                    type="text"
                                    value={formik.values.version}
                                    label={<span>Version<span className={classes.required}> *</span></span>}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    inputProps={{maxLength: 10}}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.version) && Boolean(formik.touched.version)}
                                    helperText={Boolean(formik.touched.version) && formik.errors.version}
                                />
                            </FormControl>
                        </div>   
                        <div className={`${classes.formRow} business-type`} style={{justifyContent: 'start'}}>
                            <FormControl className={classes.inputWrapper} style={{width: 150}}>                            
                                <InputLabel
                                    htmlFor="businessType"
                                    classes={{
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                    error={Boolean(formik.errors.userType) && Boolean(formik.touched.userType)}
                                >
                                    {<span>Announcement Type<span className={classes.required}> *</span></span>}
                                </InputLabel>
                                <Select
                                    value={formik.values.type}
                                    id="type"
                                    onChange={formik.handleChange}
                                    name="type"
                                    classes={{
                                        root: classes.input
                                    }}
                                    inputProps={{
                                        onBlur: formik.handleBlur
                                    }}
                                    MenuProps={{
                                        style: {
                                            top: 35
                                        }
                                    }}
                                    error={Boolean(formik.errors.type) && Boolean(formik.touched.type)}
                                >
                                    {
                                        ANNOUNCEMENT_TYPES.map(type =>
                                            <MenuItem
                                                classes= {{
                                                    'root': 'announcement-create-page-li'
                                                }}
                                                key={type.id}
                                                value={type.id}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                                {formik.touched.type &&
                                  formik.errors.type && <FormHelperText className={classes.error}>{formik.errors.type}</FormHelperText>}
                            </FormControl>
                            <div className={'announcement-switch'} style={{marginLeft: 40,paddingTop: 18,width: 80}}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={ 
                                            <Switch 
                                                label={checked?'Publish':'Draft'}
                                                checked={checked} 
                                                disabled={selectedAnnouncement && (selectedAnnouncement.status === 'Active' || selectedAnnouncement.status === 'Inactive') ? true:false}
                                                size="small" 
                                                onChange={toggleChecked}
                                            />}
                                    />
                                </FormGroup>
                            </div>
                            { checked || (selectedAnnouncement && (selectedAnnouncement.status === 'Inactive' || (selectedAnnouncement.status === 'Active' && new Date(selectedAnnouncement.endDate) < new Date(2099, 11, 31)))) ?
                                <FormControl style={{width: 130,marginLeft: '30px !important'}} className={`${classes.inputWrapperForCreateServiceCall} announcement-dt1`}>
                                    <InputLabel
                                        htmlFor="startDt"
                                        style={{transform: 'translateY(0)'}}
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.startDt) && Boolean(formik.touched.startDt)}
                                    >
                                        <span style={{fontSize: 11}}>Start Date<span style={{display: 'inline-block'}} className={classes.required}> *</span></span>
                                    </InputLabel>
                                    <DatePicker
                                        className={`${classes.calenderView} start-dt`}
                                        selected={startDt !== null ? startDt : new Date()}
                                        onChange={(date) =>setStartDt(date) }
                                        timeInputLabel="Time:"
                                        timeFormat={'h:mm a'}
                                        isClearable={false}
                                        margin="dense"
                                        disabled={selectedAnnouncement && (selectedAnnouncement.status === 'Inactive' || selectedAnnouncement.status === 'Active') ?true:false}
                                        timeIntervals={15}
                                        shouldCloseOnSelect={false}
                                        dateFormat={'MM/dd/yyyy h:mm a'}
                                        showTimeSelect={true}
                                    />
                                    {formik.touched.startDt &&
                                    formik.errors.startDt && <FormHelperText className={classes.error}>{formik.errors.startDt}</FormHelperText>}
                                </FormControl>
                                    :''
                            }
                            {selectedAnnouncement && (selectedAnnouncement.status === 'Inactive')?
                                <FormControl style={{width: 130,marginLeft: '30px !important'}} className={`${classes.inputWrapperForCreateServiceCall} announcement-dt1`}>
                                    <InputLabel
                                        htmlFor="endDt"
                                        style={{transform: 'translateY(0)'}}
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.endDt) && Boolean(formik.touched.endDt)}
                                    >
                                        <span style={{fontSize: 11}}>End Date<span style={{display: 'inline-block'}} /></span>
                                    </InputLabel>
                                    <DatePicker
                                        className={`${classes.calenderView} start-dt`}
                                        selected={endDt}
                                        onChange={(date) => setEndDt(date)}
                                        timeInputLabel="Time:"
                                        disabled={true}
                                        timeFormat="h:mm a"
                                        isClearable={false}
                                        margin="dense"
                                        timeIntervals={15}
                                        shouldCloseOnSelect={false}
                                        dateFormat="MM/dd/yyyy h:mm a"
                                        showTimeSelect={true}                                    
                                    />
                                    {formik.touched.endDt &&
                                    formik.errors.endDt && <FormHelperText className={classes.error}>{formik.errors.endDt}</FormHelperText>}
                                </FormControl>
                                    :''}
                        </div>
                        <div className={classes.formRow}>
                            <FormControl className={classes.userInputWrapper}>
                                <TextField
                                    id="title"
                                    name="title"
                                    type="text"
                                    inputProps={{maxLength: 100}}
                                    value={formik.values.title}
                                    label={<span>Title<span className={classes.required}> *</span></span>}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.title) && Boolean(formik.touched.title)}
                                    helperText={Boolean(formik.touched.title) && formik.errors.title}
                                />
                            </FormControl>
                        </div>
                        <p>
                            {<span className={aclasses.descriptionLabel}>Description<span className={classes.required}> *</span></span>}
                        </p>
                        <div className={`${classes.formRow} announcement-editor`} style={{height: 'calc(80vh - 315px)'}}>
                            <style>
                                {` .k-animation-container-relative {
                                        width:auto !important;
                                        min-width: 180px !important;
                                    }`
                                }
                            </style>
                            <Editor
                                value={editorValue}
                                onPasteHtml={(e) => {
                                    let html = pasteCleanup(sanitize(e.pastedHtml), pasteSettings);
                                    return html;
                                }}
                                onChange={onEditorChange}
                                onMount={onMount}
                                tools={[
                                    [Bold, Italic, Underline, Strikethrough], 
                                    [Subscript, Superscript], 
                                    [CustomForeColor, CustomBackColor],
                                    [AlignLeft, AlignCenter, AlignRight, AlignJustify], 
                                    [Indent, Outdent], [OrderedList, UnorderedList], 
                                    FontSize, 
                                    FontName, 
                                    FormatBlock, 
                                    [Undo, Redo], 
                                    [Link, Unlink, InsertImage, ViewHtml], 
                                    [InsertTable], 
                                    [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter], 
                                    [DeleteRow, DeleteColumn, DeleteTable], 
                                    [MergeCells, SplitCell]
                                ]}  
                                contentStyle={{
                                    height: 'calc(80vh - 415px)'
                                }}
                                defaultContent={formik.values.announcementContent?formik.values.announcementContent:''}
                            />
                        </div>
                        <div style={{marginTop: 12}}>
                            <button
                                onClick={previewClicked}
                                className="MuiButtonBase-root preview-btn MuiButton-root MuiButton-contained BobConfirmButton_Button__3_hZR CreateEntityModal_ButtonWithMargin__3GPWD" 
                                type="button"
                            >
                                <span className="MuiButton-label">Preview</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`${classes.UserInputColumn} ${aclasses.SecondCol}`} >
                    <div className="MuiDialog-container MuiDialog-scrollPaper announcement-dialog" role="none presentation">
                        <div className="MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthMd MuiPaper-rounded" role="dialog" aria-labelledby="modal-title">
                            <div className="modal BobModal_BobModal__184sV BobModal_BobModalWithoutFooter__2ZoFl">                                       
                                <div style={{display: 'block'}} className="MuiDialogTitle-root BobModal_HeaderContainer__1YgcP">
                                    {isPreview ?
                                        <React.Fragment>
                                            <span style={{fontSize: '1.5rem',fontWeight: 500}}>{previewObj.title}</span> 
                                            <span style={{marginLeft: 10}}>{`V ${previewObj.version}`}</span>
                                        </React.Fragment> 
                                        :
                                        <span />
                                    }
                                </div>
                                {isPreview? 
                                    <React.Fragment>
                                        <div className="MuiDialogContent-root k-editor" style={{border: 'none'}}>
                                            <div>    
                                                <Editor
                                                    value={editorValue}
                                                    contentStyle={{
                                                        height: 'calc(75vh - 100px)'
                                                    }}
                                                    defaultContent={previewObj.announcementContent}
                                                />                                     
                                            </div>
                                        </div>
                                    </React.Fragment>:
                                    <div className="MuiDialogContent-root" >
                                        <div className="modal-content">
                                            <i className="fa fa-info-circle" aria-hidden="true" />
                                            <div className="msg">Click on 'Preview' to see how the Release Notes will be displayed for the users.</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{marginTop: 15}}>
                <Button
                    className={classes.Button}
                    style={{marginBottom: 15}}
                    variant="contained"
                    onClick={handleBackClick}
                >
                    Cancel
                </Button>
                {currentUser.isSuperUser ?
                    <React.Fragment>
                        {selectedAnnouncement && selectedAnnouncement.status === 'Inactive' ? '' :
                        <BobConfirmButton
                            className={classes.ButtonWithMargin} 
                            isLoading={isLoading} 
                            disabled = {false}
                            onClick={handleSave} 
                            label={'Save'}
                        />}
                    </React.Fragment>:''}
            </div>
        </div>
    );
};

AnnouncementCreate.propTypes = {
    close:       func,
    companyInfo: object,
    currentUser: object,
    errors:      array,
    isLoading:   bool,
    open:        bool,
    rule:        object,
    title:       string
};

const mapStateToProps = state => {
    return {
        companyInfo:        state.companyInfo,
        currentUser:        state.currentUser,
        errors:             state.messages.errors,
        entityRules:        state.bob.entityRules,
        isLoading:          state.ui.isLoading,
        navClients:         state.bob.navClients,
        sites:              state.site.sites,
        targetNavClient:    state.bob.targetNavClient,
        targetNavSite:      state.bob.targetNavSite,
        targetNavEquipment: state.bob.targetNavEquipment,
        seniorityLevels:    state.architect.seniorityLevels,
        specialties:        state.architect.specialties
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementCreate);
